export { default as ListadoBitacora } from './Listado';
export { default as DetalleBitacora } from './Detalle';
